import React, { useState, useEffect } from 'react';
import DataTableDocumentActionModal from 'components/DataTableDocumentActionModal';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import FormField from 'layouts/applications/wizard/components/FormField';
import ComunaSelector from 'components/ComunaSelector';
import Swal from 'sweetalert2';
import axios from 'axios';

const CreateNewModal = ({ show, handleClose, getData, document, onClose }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        nombre: '',
        razon_social: '',
        id_comuna: 0,
        rut: '',
        direccion: '',
        telefono: '',
        fax: '',
        email: '',
        web: ''
    });

    useEffect(() => {
        if(document) {
            setFormData({
                nombre: document.nombre,
                razon_social: document.razon_social,
                rut: document.rut,
                id_comuna: document.id_comuna,
                direccion: document.direccion,
                comuna: document.comuna,
                telefono: document.telefono,
                fax: document.fax || '',
                email: document.email || '',
                web: document.web || ''
            });
        } else {
            setFormData({
                nombre: '',
                razon_social: '',
                id_comuna: 0,
                rut: '',
                direccion: '',
                telefono: '',
                fax: '',
                email: '',
                web: ''
            });
        }
    }, [document]);

    const handleSubmit = async () => {
        try {
            setIsLoading(true);
            const url = document 
                ? `${process.env.REACT_APP_SERVER_URL}/api/maintenance/client/${document.id}/`
                : `${process.env.REACT_APP_SERVER_URL}/api/maintenance/clients/`;
            
            const response = document
                ? await axios.put(url, formData)
                : await axios.post(url, formData);

            getData();
            Swal.fire({
                icon: 'success',
                title: document ? 'Cliente actualizado' : 'Cliente creado',
                text: `El cliente ha sido ${document ? 'actualizado' : 'creado'} exitosamente`,
            });
        } catch(error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: `Ocurrió un error al ${document ? 'actualizar' : 'crear'} el cliente`,
            });
        } finally {
            handleClose();
            onClose && onClose();
            setIsLoading(false);
        }
    };

    const handleChange = (field) => (e) => {
        setFormData({ ...formData, [field]: e?.target?.value || e });
    };

    return (
        <DataTableDocumentActionModal
            show={show}
            handleClose={() => {
                handleClose();
                onClose && onClose();
            }}
            title={document ? "Editar Cliente" : "Nuevo Cliente"}
            handleSubmit={handleSubmit}
            isSubmitting={isLoading}
            submitText={document ? "Actualizar" : "Crear"}
        >
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <FormField
                        type="text"
                        label="Nombre"
                        value={formData.nombre}
                        onChange={handleChange('nombre')}
                        placeholder="Ingrese el nombre del cliente"
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        type="text"
                        label="Razón Social"
                        value={formData.razon_social}
                        onChange={handleChange('razon_social')}
                        placeholder="Ingrese la razón social"
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        type="text"
                        label="RUT"
                        value={formData.rut}
                        onChange={handleChange('rut')}
                        placeholder="Ingrese el RUT"
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        type="text"
                        label="Dirección"
                        value={formData.direccion}
                        onChange={handleChange('direccion')}
                        placeholder="Ingrese la dirección"
                    />
                </Grid>
                <Grid item xs={6}>
                    <ComunaSelector
                        selectedComuna={formData.id_comuna}
                        setSelectedComuna={({ value }) => {
                            setFormData({ ...formData, id_comuna: value });
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        type="text"
                        label="Teléfono"
                        value={formData.telefono}
                        onChange={handleChange('telefono')}
                        placeholder="Ingrese el número de teléfono"
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        type="text"
                        label="Fax"
                        value={formData.fax}
                        onChange={handleChange('fax')}
                        placeholder="Ingrese el número de fax"
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        type="email"
                        label="Email"
                        value={formData.email}
                        onChange={handleChange('email')}
                        placeholder="Ingrese el correo electrónico"
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        type="url"
                        label="Web"
                        value={formData.web}
                        onChange={handleChange('web')}
                        placeholder="Ingrese el sitio web"
                    />
                </Grid>
            </Grid>
        </DataTableDocumentActionModal>
    );
};

CreateNewModal.propTypes = {
    show: PropTypes.bool,
    getData: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    document: PropTypes.object,
    onClose: PropTypes.func,
};

export default CreateNewModal;